import React         from 'react';
import ReactDom      from 'react-dom';

// -------------------------------------------------------

class ProjectNotAccess extends React.Component {
  render() {
    let data    = this.props.data;
    let project = data.project || {};

    return (
      <div id="project">
        <div className="project-header">
          <div className="project-title">
            <a href="/"><i className="material-icons">chevron_left</i></a>
            <p>{project.title}</p>
          </div>
        </div>
        
        <div className="project-container">
          <div className="project-not-access">プロジェクトのアクセス権限がありません</div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectNotAccess;